document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.querySelector('.description-toggle-btn');
    const accordion = toggleBtn.closest('.product-description-accordion');
    const content = accordion.querySelector('.prose');
    const gradient = accordion.querySelector('.bg-gradient-to-t');
    const icon = toggleBtn.querySelector('svg');
    const span = toggleBtn.querySelector('span');

    toggleBtn.addEventListener('click', function() {
        if(accordion.classList.contains('expanded')) {
            // Kapat
            accordion.classList.remove('expanded');
            accordion.classList.add('collapsed');
            accordion.style.maxHeight = '200px';
            gradient.style.opacity = '1';
            icon.style.transform = 'rotate(0deg)';
            span.textContent = 'Pokaż więcej';
        } else {
            // Aç
            accordion.classList.remove('collapsed');
            accordion.classList.add('expanded');
            accordion.style.maxHeight = accordion.scrollHeight + 'px';
            gradient.style.opacity = '0';
            icon.style.transform = 'rotate(180deg)';
            span.textContent = 'Pokaż mniej';
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanes = document.querySelectorAll('.tab-pane');

    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabName = this.getAttribute('data-tab');

            // Remove active class from all buttons and panes
            tabButtons.forEach(btn => {
                btn.classList.remove('active');
                btn.classList.remove('border-b-2', 'border-primary-500');
                btn.classList.add('border-b-2', 'border-transparent');
            });
            tabPanes.forEach(pane => pane.classList.remove('active'));

            // Add active class to clicked button and corresponding pane
            this.classList.add('active');
            this.classList.remove('border-b-2', 'border-transparent');
            this.classList.add('border-b-2', 'border-primary-500');
            document.getElementById(tabName).classList.add('active');
        });
    });
});